export default {
  open: [
    {
      _name: "CSidebarNavTitle",
      _children: ["Bán hàng"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Tin đăng v2",
      to: "/v2/posts",
      icon: "cil-star",
      permission: 'product_posting_list'
    },
    {
      _name: "CSidebarNavItem",
      name: "Tin đăng v3",
      to: "/v2/posts_readonly",
      icon: "cil-star",
      permission: 'product_posting_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Thống kê KH liên hệ",
      to: "/sales/customers",
      icon: "cil-star",
      permission: 'product_posting_analytics'
    },
    {
      _name: "CSidebarNavItem",
      name: "Thống kê tin đăng v2",
      to: "/v2/posts/analytics",
      icon: "cil-star",
      permission: 'product_posting_analytics'
    },
  ],
  sale_limited: [
    {
      _name: "CSidebarNavTitle",
      _children: ["Bán hàng"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Tin đăng v2",
      to: "/v2/posts",
      icon: "cil-star",
      permission: 'product_posting_list'
    },
    {
      _name: "CSidebarNavItem",
      name: "Tin đăng v3",
      to: "/v2/posts_readonly",
      icon: "cil-star",
      permission: 'product_posting_view'
    },
  ], 
  
  ctv_limited: [
    {
      _name: "CSidebarNavTitle",
      _children: ["Bán hàng"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Tin đăng v3",
      to: "/v2/posts_readonly",
      icon: "cil-star",
      permission: 'product_posting_view'
    },
  ],
} ;
  